import { render, staticRenderFns } from "./le-observe-choose.vue?vue&type=template&id=64a886dc&"
import script from "./le-observe-choose.vue?vue&type=script&lang=js&"
export * from "./le-observe-choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports